@if (filterShow$$()) {
    <div class="filter-container"
        @filterShow
        (@filterShow.done)="emit_filterShowDone()"
        >
        <div class="filter-slide" @slideFilterContent>
        <div class="filter-content">

            @if (settingsOpen$$()) {
                <div #settingsPanel class="filter-settings" @settingsPanel>
                    <div #settingsGrid class="settings-grid">
                        @for (field of orderedFields$$(); track field) {
                            <div class="settings-row">
                                <label class="settings-label-wrap">
                                    <span class="settings-label settings-flip-item">{{ fieldLabel(field) }}</span>
                                    <mat-checkbox class="settings-control settings-flip-item"
                                        [checked]="fieldActive(field)"
                                        (change)="emit_searchField_toggle(field)"
                                    />
                                </label>
                                <app-button-neutral class="settings-control settings-sort settings-flip-item"
                                    (btnClick)="emit_sort_toggle(field)"
                                    (click)="$event.stopPropagation()"
                                    [class.settings-sort-active]="!!sortDirection(field)"
                                    [tooltip]="'sorteren op ' + fieldLabel(field)"
                                    [tooltipPosition]="'left'"
                                >
                                    <app-icon [name]="sortDirection(field) === 'asc' ? 'sort-asc' : sortDirection(field) === 'desc' ? 'sort-desc' : 'sort'" />
                                </app-button-neutral>
                            </div>
                        }
                        <div class="settings-divider"></div>
                        <div class="settings-row settings-mode">
                            <span class="settings-label">filter mode</span>
                            <app-button-neutral class="settings-control"
                                (btnClick)="emit_filterMode_toggle()"
                                [tooltip]="filterMode_tooltip$$()"
                                [tooltipPosition]="'left'"
                            >
                                <span class="mode-icon">{{ filterMode_icon$$() }}</span>
                            </app-button-neutral>
                        </div>
                    </div>
                </div>
            }

            <div class="filter-row">
                <div class="filter-navigation">
                    <mat-button-toggle-group name="filterPreDefined">
                        <ng-content select="[preDefinedButton]" />
                    </mat-button-toggle-group>
                </div>
                <div class="filter-input" [title]="filterSyntaxHint">
                    <app-input-control #inputControlComponent
                        (focusin)="emit_focusIn()"
                        (onfocusout)="emit_focusOut()"
                        [control]="filterControl"
                        [classHeight]="'xs-height'"
                        [placeholder]="'filter text'"
                    />
                    @if (filterControl.value) {
                        <button class="filter-clear" type="button"
                            (click)="emit_filterClear()"
                            [title]="'wis filtertekst'"
                        >
                            <app-icon name="xmark" />
                        </button>
                    }
                </div>
                <div #ellipsisBtn class="filter-ellipsis">
                    <app-button-neutral
                        (btnClick)="emit_settings_toggle()"
                        [tooltip]="'filter instellingen'"
                        [tooltipPosition]="'above'"
                    >
                        <app-icon name="ellipsis-v" />
                    </app-button-neutral>
                </div>
            </div>
            </div>
        </div>
    </div>
}
